
import { axios } from '@/utils/request'

const api = {
  options: '/adminapi/jiandu/options',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}
